
export default {
  name: 'FileItem',
  props: {
    title: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'file',
      validator(value) {
        return ['file', 'link'].includes(value)
      },
    },
    updatedAt: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'dark'].includes(value)
      },
    },
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'link':
          return 'tmt250/link'
        case 'file':
          return 'globals/download'
        default:
          return 'tmt250/link'
      }
    },
  },
}
